/**
 * comments.js starts
 * Created by mac on 14.03.2018.
 */

$(function () {
  
  var $answerLink = $('.link-answer');
  
  /*Открытие формы ответа*/
  $answerLink.on('click', function (e) {
    var $link = $(this),
        t             = $link.attr('href'),
        commentid     = $link.data('commentid'),
        $answerForm   = $(t),
        $commentInput = $answerForm.find('.input-commentid');
  
    $commentInput.val(commentid);
    $link.parent().append($answerForm);
    
    if (!$answerForm.is(':visible')) {
      $answerForm.slideDown(200);
    }
    e.preventDefault();
  });
  
  /*Закрытие формы ответа*/
  $(document).on('click', '.close-answer-form', function (e) {
    $(this).parent().slideUp(200);
  });
  
  
});
/* comments.js ends */